import { Component, Input } from '@angular/core';

import { SearchActivityEvents } from 'generated/graphql';

@Component({
  selector: 'app-connection-event',
  templateUrl: './connection-event.component.html'
})

export class ASConnectionEventComponent {

  @Input() item: SearchActivityEvents.Node;
  /**
   *
   */
  constructor(
  ) {
  }
}
